import { render, staticRenderFns } from "./BarChartCardView.vue?vue&type=template&id=532c63df"
import script from "./BarChartCardView.vue?vue&type=script&lang=js"
export * from "./BarChartCardView.vue?vue&type=script&lang=js"
import style0 from "./BarChartCardView.vue?vue&type=style&index=0&id=532c63df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports